import { Settings } from 'luxon';
import React, { useEffect } from 'react';
import { CookiesProvider } from 'react-cookie';
import { QueryCache, ReactQueryCacheProvider, useQuery } from 'react-query';
import { Route, Routes } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import Dashboard from './Components/Dashboard/Dashboard';
import Vitrine from './Components/Vitrine/Vitrine';
import { etatUtilisateurConnecte } from './State';
import { sessionOuverte, useCreateEntite, useGetQuery } from './Utils/api';
import { DialogProvider } from './Utils/dialogContext';
import { pdfjs } from 'react-pdf';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorPage from './Components/Common/ErrorPage';
import { Erreur } from '../../common/src/entities';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from './Components/Common/LanguageSwitcher';
import './Styles/Vitrine/Video.scss';
import { etatMasquerCovid19 } from './State';
import { OptionsCovid } from './Components/Dashboard/Options/Options';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

Settings.defaultLocale = 'fr';
const oneHourInMs: number = 3600000 as const;
const queryCache = new QueryCache({
    defaultConfig: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});

function App(): React.ReactElement {
    const [, setEtatUtilisateurConnecte] = useRecoilState(etatUtilisateurConnecte);
    const [masquerCovid19, setMasquerCovid19] = useRecoilState(etatMasquerCovid19);
    const { data } = useQuery('estConnecte', sessionOuverte);
    const [signalerErreur] = useCreateEntite(Erreur);
    const { i18n } = useTranslation();

    const queryCovid = useGetQuery<OptionsCovid>(['options/covid']);

    useEffect(() => {
        if (queryCovid.data) {
            setMasquerCovid19({ estMasquer: queryCovid.data.texte === '1' });
        }
    }, [queryCovid]);

    useEffect(() => {
        i18n.changeLanguage(Object.keys(SUPPORTED_LANGUAGES)[0]);
        if (data?.connecte) {
            setEtatUtilisateurConnecte({
                id: data.id,
                connecte: true,
                admin: data.admin,
                nom: data.nom,
                prenom: data.prenom,
                mettreAJourMotDePasse: data.mettreAJourMotDePasse,
            });
        } else {
            setEtatUtilisateurConnecte({
                id: 0,
                connecte: false,
                admin: false,
                nom: '',
                prenom: '',
                mettreAJourMotDePasse: false,
            });
        }
    }, [data]);

    return (
        <ErrorBoundary
            FallbackComponent={ErrorPage}
            onReset={() => {
                setTimeout(() => window.location.reload(), 250);
                window.history.back();
            }}
            onError={(error: Error) => {
                signalerErreur(Erreur.fromError(error));
            }}
        >
            <CookiesProvider>
                <ReactQueryCacheProvider queryCache={queryCache}>
                    <DialogProvider>
                        <Routes>
                            <Route path="/dashboard/*" element={<Dashboard />} />
                            <Route path="/*" element={<Vitrine />} />
                        </Routes>
                    </DialogProvider>
                </ReactQueryCacheProvider>
            </CookiesProvider>
        </ErrorBoundary>
    );
}

export default App;
